import React, { useEffect, useState } from 'react';
import { Modal } from 'antd';
import { HeadsUpModalBody } from './smartDefaults.style';
import { getHeadsUpCopy } from './headsUpCopy';

const HeadsUpModal = ({
    open,
    handEditedCount,
    saving,
    onCancel,
    onConfirm,
}) => {
    const [choice, setChoice] = useState('keep');
    const copy = getHeadsUpCopy(handEditedCount);

    useEffect(() => {
        if (open) {
            setChoice('keep');
        }
    }, [open]);

    const handleConfirm = () => {
        onConfirm?.(choice === 'overwrite');
    };

    return (
        <Modal
            open={open}
            onCancel={onCancel}
            footer={null}
            width={480}
            centered
            destroyOnClose
            className="smart-defaults-heads-up-modal"
            title={null}
        >
            <HeadsUpModalBody>
                <div className="heads-up-label">Heads up</div>
                <h2 className="heads-up-title">{copy.title}</h2>
                <p className="heads-up-description">{copy.description}</p>

                <div className="heads-up-options">
                    <button
                        type="button"
                        className={`heads-up-option heads-up-option--recommended ${choice === 'keep' ? 'heads-up-option--selected' : ''}`}
                        onClick={() => setChoice('keep')}
                        disabled={saving}
                        aria-pressed={choice === 'keep'}
                    >
                        <div className="heads-up-option-header">
                            <span className="heads-up-option-title">Keep my edits</span>
                            <span className="heads-up-recommended-badge">Recommended</span>
                        </div>
                        <p className="heads-up-option-desc">
                            Only products still on defaults get the new value. Your manual numbers stay exactly as you set them.
                        </p>
                    </button>

                    <button
                        type="button"
                        className={`heads-up-option heads-up-option--overwrite ${choice === 'overwrite' ? 'heads-up-option--selected' : ''}`}
                        onClick={() => setChoice('overwrite')}
                        disabled={saving}
                        aria-pressed={choice === 'overwrite'}
                    >
                        <div className="heads-up-option-header">
                            <span className="heads-up-option-title">Overwrite everything</span>
                        </div>
                        <p className="heads-up-option-desc">{copy.overwriteDescription}</p>
                    </button>
                </div>

                <div className="heads-up-modal-actions">
                    <button type="button" className="heads-up-cancel-btn" onClick={onCancel} disabled={saving}>
                        Cancel
                    </button>
                    <button
                        type="button"
                        className="heads-up-confirm-btn"
                        onClick={handleConfirm}
                        disabled={saving}
                    >
                        {saving ? 'Saving…' : 'Confirm'}
                    </button>
                </div>
            </HeadsUpModalBody>
        </Modal>
    );
};

export default HeadsUpModal;
